import { jsx } from "react/jsx-runtime";
const GlassWater = ({ isHovered }) => {
  const normal = /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      d: "m15.404 40.373-3-32.748h23.192l-3 32.748H15.404Zm-1.13-25.475-.555-6.073H34.28l-.605 6.609c-1.056.596-3.273 1.689-5.94 1.284-1.444-.219-2.245-.63-3.163-1.1l-.175-.09c-1.03-.526-2.199-1.079-4.366-1.405-1.296-.195-2.629-.095-3.775.147a9.87 9.87 0 0 0-1.982.628Zm.118 1.282L16.5 39.173h15l2.044-22.313c-1.308.644-3.46 1.428-5.99 1.045-1.64-.249-2.587-.736-3.521-1.215l-.182-.093c-.96-.491-2.002-.987-3.998-1.288-1.126-.17-2.312-.084-3.35.135-.89.188-1.63.466-2.112.736Z"
    }
  );
  const normalHover = /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      d: "m12.404 7.625 3 32.748h17.192l3-32.748H12.404Zm2.153 10.349 1.942 21.2H31.5l1.954-21.334c-1.41-.262-2.28-.71-3.14-1.15l-.18-.093c-.961-.491-2.003-.987-4-1.288-1.125-.17-2.31-.084-3.348.135-1.048.22-1.89.567-2.343.878a.597.597 0 0 1-.06.037l-.166.097c-.962.57-2.91 1.722-5.661 1.518Zm-.112-1.214c2.473.248 4.206-.773 5.175-1.344.06-.036.117-.07.172-.101.63-.425 1.626-.809 2.747-1.045 1.146-.242 2.48-.342 3.775-.147 2.167.326 3.336.879 4.366 1.405l.176.09c.816.419 1.541.79 2.71 1.022l.715-7.815H13.718l.727 7.935Z"
    }
  );
  return isHovered ? normalHover : normal;
};
export {
  GlassWater as default
};
//# sourceMappingURL=GlassWater.js.map
